import { useStoreState } from "../../../store/hooks";
import { User } from "../../auth/models";

export const useCurrentUser = (): User | null => {
    return useStoreState((state) => state.auth.currentUser);
};
